import React, { useState } from 'react';
import { downloadExport, type ExportFormat, type ExportParams } from '@/utils/downloadExport';

type Props = {
  path: string;
  params?: ExportParams | object;
  disabled?: boolean;
  className?: string;
};

export default function ExportButtons({ path, params = {}, disabled = false, className = '' }: Props) {
  const [loading, setLoading] = useState<ExportFormat | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function run(format: ExportFormat) {
    setLoading(format);
    setError(null);
    try {
      await downloadExport(path, params, format);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Export failed');
    } finally {
      setLoading(null);
    }
  }

  return (
    <div className={['export-buttons', className].filter(Boolean).join(' ')}>
      <button
        type="button"
        className="btn btn-sm btn-ghost"
        disabled={disabled || loading !== null}
        onClick={() => void run('csv')}
      >
        {loading === 'csv' ? 'Exporting CSV…' : 'Export CSV'}
      </button>
      <button
        type="button"
        className="btn btn-sm btn-ghost"
        disabled={disabled || loading !== null}
        onClick={() => void run('json')}
      >
        {loading === 'json' ? 'Exporting JSON…' : 'Export JSON'}
      </button>
      {error ? <span className="export-buttons__error text-danger">{error}</span> : null}
    </div>
  );
}
